var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "hero-section" }, [
      _c("div", { staticClass: "container container-medium" }, [
        _c("h1", { staticClass: "text-center heading black" }, [
          _vm._v(_vm._s(_vm.$t("bp_company_advantages"))),
        ]),
        _c("div", { staticClass: "line" }),
        _c("h2", { staticClass: "text-center heading heading-medium" }, [
          _vm._v(_vm._s(_vm.$t("bp_one_account_multiple_advantages"))),
        ]),
        _c(
          "div",
          { staticClass: "text-center" },
          [
            _c("router-link", { attrs: { to: { name: "contact" } } }, [
              _c("div", { staticClass: "btn btn-purple" }, [
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("bp_contact_us_for_personalized_solution")) +
                    " "
                ),
              ]),
            ]),
          ],
          1
        ),
      ]),
    ]),
    _c("div", { staticClass: "online-emit-section" }, [
      _c("div", { staticClass: "container container-medium" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-lg-6 col-md-6 col-sm-12 order-1 order-md-0" },
            [
              _c("h2", { staticClass: "heading heading-medium" }, [
                _vm._v(_vm._s(_vm.$t("bp_online_emission"))),
              ]),
              _c("div", [_vm._v(_vm._s(_vm.$t("bp_online_assistance")) + ".")]),
            ]
          ),
          _vm._m(0),
        ]),
      ]),
    ]),
    _c("div", { staticClass: "container container-wide import-park-section" }, [
      _c("div", { staticClass: "row m-0" }, [
        _vm._m(1),
        _c("div", { staticClass: "col-lg-6 col-md-6 col-sm-12" }, [
          _c("h2", { staticClass: "heading heading-medium" }, [
            _vm._v(_vm._s(_vm.$t("bp_import_your_cars"))),
          ]),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-lg-7" }, [
              _vm._v(_vm._s(_vm.$t("bp_import_you_cars_through_excel"))),
            ]),
          ]),
        ]),
      ]),
    ]),
    _vm.isMobile()
      ? _c("div", { staticClass: "plus-section container container-medium" }, [
          _c(
            "h2",
            { staticClass: "text-center extra-bold heading heading-medium" },
            [_vm._v(_vm._s(_vm.$t("bp_heading")))]
          ),
          _c(
            "div",
            { staticClass: "row justify-content-center mt-4 mt-md-5" },
            [
              _c(
                "carousel",
                { attrs: { "per-page": 1, "mouse-drag": false } },
                [
                  _c("slide", [
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-lg-4 col-md-6 col-sm-12 col-12 mb-5 text-center",
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "d-flex justify-content-center" },
                          [
                            _c("div", {
                              staticClass: "icon many-profiles-icon",
                            }),
                          ]
                        ),
                        _c("h3", { staticClass: "heading heading-small" }, [
                          _vm._v(_vm._s(_vm.$t("bp_multiple_profiles"))),
                        ]),
                        _c("p", { staticClass: "reading" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("bp_multiple_profiles_for_same_email")
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-lg-4 col-md-6 col-sm-12 col-12 mb-5 text-center",
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "d-flex justify-content-center" },
                          [
                            _c("div", {
                              staticClass: "icon rovignette-status-icon",
                            }),
                          ]
                        ),
                        _c("h3", { staticClass: "heading heading-small" }, [
                          _vm._v(_vm._s(_vm.$t("bp_vignettes_status"))),
                        ]),
                        _c("p", { staticClass: "reading" }, [
                          _vm._v(_vm._s(_vm.$t("bp_verify_vignette_status"))),
                        ]),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-lg-4 col-md-6 col-sm-12 col-12 text-center",
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "d-flex justify-content-center" },
                          [
                            _c("div", {
                              staticClass: "icon comands-history-icon",
                            }),
                          ]
                        ),
                        _c("h3", { staticClass: "heading heading-small" }, [
                          _vm._v(_vm._s(_vm.$t("bp_orders_history"))),
                        ]),
                        _c("p", { staticClass: "reading" }, [
                          _vm._v(
                            _vm._s(_vm.$t("bp_orders_history_description"))
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("slide", [
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-lg-4 col-md-6 col-sm-12 col-12 mb-5 text-center",
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "d-flex justify-content-center" },
                          [
                            _c("div", {
                              staticClass: "icon multiple-comands-icon",
                            }),
                          ]
                        ),
                        _c("h3", { staticClass: "heading heading-small" }, [
                          _vm._v(_vm._s(_vm.$t("bp_multiple_orders"))),
                        ]),
                        _c("p", { staticClass: "reading" }, [
                          _vm._v(
                            _vm._s(_vm.$t("bp_multiple_orders_description"))
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-lg-4 col-md-6 col-sm-12 col-12 mb-5 text-center",
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "d-flex justify-content-center" },
                          [
                            _c("div", {
                              staticClass: "icon notificare-expirare-icon",
                            }),
                          ]
                        ),
                        _c("h3", { staticClass: "heading heading-small" }, [
                          _vm._v(_vm._s(_vm.$t("bp_email_sms_confirmation"))),
                        ]),
                        _c("p", { staticClass: "reading" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("bp_email_sms_confirmation_description")
                            ) + " "
                          ),
                          _c("span", { staticClass: "free-label" }, [
                            _vm._v(_vm._s(_vm.$t("free"))),
                          ]),
                        ]),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-lg-4 col-md-6 col-sm-12 col-12 text-center",
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "d-flex justify-content-center" },
                          [
                            _c("div", {
                              staticClass: "icon servicii-profesioniste-icon",
                            }),
                          ]
                        ),
                        _c("h3", { staticClass: "heading heading-small" }, [
                          _vm._v(_vm._s(_vm.$t("bp_expiry_alerts"))),
                        ]),
                        _c("p", { staticClass: "reading" }, [
                          _vm._v(
                            _vm._s(_vm.$t("bp_expiry_alerts_description"))
                          ),
                        ]),
                      ]
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ])
      : _vm._e(),
    !_vm.isMobile()
      ? _c("div", { staticClass: "plus-section container container-medium" }, [
          _c(
            "h2",
            { staticClass: "text-center extra-bold heading heading-medium" },
            [_vm._v(_vm._s(_vm.$t("bp_heading")))]
          ),
          _c(
            "div",
            { staticClass: "row justify-content-center mt-4 mt-md-5" },
            [
              _c(
                "div",
                {
                  staticClass:
                    "col-lg-4 col-md-6 col-sm-12 col-12 mb-5 text-center",
                },
                [
                  _vm._m(2),
                  _c("h3", { staticClass: "heading heading-small" }, [
                    _vm._v(_vm._s(_vm.$t("bp_multiple_profiles"))),
                  ]),
                  _c("p", { staticClass: "reading" }, [
                    _vm._v(
                      _vm._s(_vm.$t("bp_multiple_profiles_for_same_email"))
                    ),
                  ]),
                ]
              ),
              _c(
                "div",
                {
                  staticClass:
                    "col-lg-4 col-md-6 col-sm-12 col-12 mb-5 text-center",
                },
                [
                  _vm._m(3),
                  _c("h3", { staticClass: "heading heading-small" }, [
                    _vm._v(_vm._s(_vm.$t("bp_vignettes_status"))),
                  ]),
                  _c("p", { staticClass: "reading" }, [
                    _vm._v(_vm._s(_vm.$t("bp_verify_vignette_status"))),
                  ]),
                ]
              ),
              _c(
                "div",
                {
                  staticClass:
                    "col-lg-4 col-md-6 col-sm-12 col-12 mb-5 text-center",
                },
                [
                  _vm._m(4),
                  _c("h3", { staticClass: "heading heading-small" }, [
                    _vm._v(_vm._s(_vm.$t("bp_orders_history"))),
                  ]),
                  _c("p", { staticClass: "reading" }, [
                    _vm._v(_vm._s(_vm.$t("bp_orders_history_description"))),
                  ]),
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "col-lg-4 col-md-6 col-sm-12 col-12 text-center",
                },
                [
                  _vm._m(5),
                  _c("h3", { staticClass: "heading heading-small" }, [
                    _vm._v(_vm._s(_vm.$t("bp_multiple_orders"))),
                  ]),
                  _c("p", { staticClass: "reading" }, [
                    _vm._v(_vm._s(_vm.$t("bp_multiple_orders_description"))),
                  ]),
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "col-lg-4 col-md-6 col-sm-12 col-12 text-center",
                },
                [
                  _vm._m(6),
                  _c("h3", { staticClass: "heading heading-small" }, [
                    _vm._v(_vm._s(_vm.$t("bp_email_sms_confirmation"))),
                  ]),
                  _c("p", { staticClass: "reading" }, [
                    _vm._v(
                      _vm._s(_vm.$t("bp_email_sms_confirmation_description")) +
                        " "
                    ),
                    _c("span", { staticClass: "free-label" }, [
                      _vm._v(_vm._s(_vm.$t("free"))),
                    ]),
                  ]),
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "col-lg-4 col-md-6 col-sm-12 col-12 text-center",
                },
                [
                  _vm._m(7),
                  _c("h3", { staticClass: "heading heading-small" }, [
                    _vm._v(_vm._s(_vm.$t("bp_expiry_alerts"))),
                  ]),
                  _c("p", { staticClass: "reading" }, [
                    _vm._v(_vm._s(_vm.$t("bp_expiry_alerts_description"))),
                  ]),
                ]
              ),
            ]
          ),
        ])
      : _vm._e(),
    _c("div", { staticClass: "need-help-section container container-small" }, [
      _c("div", { staticClass: "row justify-content-center" }, [
        _c("div", { staticClass: "col-lg-8 col-md-8 col-sm-12 col-12" }, [
          _c("h2", { staticClass: "text-center heading heading-medium" }, [
            _vm._v(_vm._s(_vm.$t("bp_need_help"))),
          ]),
          _vm._m(8),
          _c("p", { staticClass: "reading text-center" }, [
            _vm._v(_vm._s(_vm.$t("bp_call_operators"))),
          ]),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "text-center" },
        [
          _c(
            "router-link",
            {
              staticClass: "main-link",
              attrs: { to: { name: "distribution" } },
            },
            [_vm._v(_vm._s(_vm.$t("bp_offices")))]
          ),
        ],
        1
      ),
    ]),
    _c("div", { staticClass: "flota-section container container-small mt-5" }, [
      _c("div", [
        _c("h2", { staticClass: "text-center heading heading-medium" }, [
          _vm._v(_vm._s(_vm.$t("bp_have_cars"))),
        ]),
        _vm._m(9),
        _c("p", { staticClass: "text-center mb-4 reading" }, [
          _vm._v(
            _vm._s(
              _vm.$t(
                "bp_contact_us_for_personalized_solution_for_your_bussiness"
              )
            )
          ),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "text-center" },
        [
          _c("router-link", { attrs: { to: { name: "contact" } } }, [
            _c("div", { staticClass: "main-btn", attrs: { href: "/" } }, [
              _vm._v(" " + _vm._s(_vm.$t("bp_contact_us_now")) + " "),
            ]),
          ]),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "col-lg-6 col-md-6 col-sm-11 col-11 order-0 order-md-1" },
      [
        _c("img", {
          attrs: {
            src: require("../media/img_24h@2x.png"),
            alt: "24h available service",
          },
        }),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-lg-6 col-md-6 col-sm-12 pl-0" }, [
      _c("img", {
        attrs: {
          src: require("../media/beneficii@2x.png"),
          alt: "24h available service",
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "d-flex justify-content-center" }, [
      _c("div", { staticClass: "icon many-profiles-icon" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "d-flex justify-content-center" }, [
      _c("div", { staticClass: "icon rovignette-status-icon" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "d-flex justify-content-center" }, [
      _c("div", { staticClass: "icon comands-history-icon" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "d-flex justify-content-center" }, [
      _c("div", { staticClass: "icon multiple-comands-icon" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "d-flex justify-content-center" }, [
      _c("div", { staticClass: "icon notificare-expirare-icon" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "d-flex justify-content-center" }, [
      _c("div", { staticClass: "icon servicii-profesioniste-icon" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "d-flex justify-content-center my-3" }, [
      _c("div", { staticClass: "icon need-help-icon" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "d-flex justify-content-center my-3" }, [
      _c("div", { staticClass: "icon flota-auto-icon" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }